<template>
  <el-form-item :label="currentField.label" :label-width="currentField.labelWidth + 'px'">
<!--    <el-select v-if="update"-->
<!--    v-model="currentField.componentValue"-->
<!--    placeholder="Select" :loading="loading" v-bind="attributesBinding">-->
<!--      <el-option-->
<!--        v-for="item in currentField.options"-->
<!--        :key="item.optionLabel"-->
<!--        :value="item.optionValue"-->
<!--        :label="item.optionLabel"-->
<!--        :disabled="item.disabled"-->
<!--      ></el-option>-->
<!--    </el-select>-->
   <select class="form-control max_width" v-if="update" v-model="currentField.componentValue" :disabled="loading" v-bind="attributesBinding">
     <option value="" disabled selected>Select</option>
     <option v-for="item in currentField.options" :key="item.optionValue" :value="item.optionValue" :disabled="item.disabled" >
       {{ item.optionLabel }}
     </option>
   </select>
  </el-form-item>
</template>

<script>
import fetchData from '../api/fetch-data';
import qs from 'qs';

export default {
  name: 'SelectList',
  props: ['currentField'],
  data() {
    return {
      update: true,
      value: '',
      loading: false
    };
  },
  mounted() {
    if (this.currentField.isFromUrl) {
      let dataUrl = this.currentField.dataUrl;
      let valueField = this.currentField.valueField;
      let labelField = this.currentField.labelField;

      let promise = fetchData.fetchOptionsData(dataUrl, labelField, valueField);
      promise.then((data) => {
        this.currentField.options = data;
      });
    }
    if(this.currentField.defaultValue){
      this.currentField.componentValue = this.currentField.defaultValue
    }
  },
  computed: {
    attributesBinding() {
      var attr = {};
      attr.disabled = this.currentField.disabled;
      attr.clearable = this.currentField.clearable;
      attr.multiple = this.currentField.multiple;
      attr.filterable = this.currentField.filterable;
      attr.remote = this.currentField.remote;
      if (attr.remote) {
        attr.remoteMethod = this.remoteMethod;
      }
      return attr;
    }
  },
  methods: {
    reload() {
      this.update = false;
      this.$nextTick(() => {
        this.update = true;
      });
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        let dataUrl = this.currentField.dataUrl;
        let valueField = this.currentField.valueField;
        let labelField = this.currentField.labelField;
        var param = { queryStr: query };
        let promise = fetchData.fetchOptionsData(dataUrl, labelField, valueField, qs.stringify(param));
        promise.then((data) => {
          this.currentField.options = data;
          this.loading = false;
        });
      } else {
        this.currentField.options = [];
      }
    }
  },
  watch: {
    'currentField.multiple'() {
      this.reload();
    }
  }
};
</script>
<style>
.max_width {
  max-width: 50% !important;
}
/* Media query for screens with a maximum width of 767px (typical for mobile devices) */
@media only screen and (max-width: 767px) {
  .max_width {
    max-width: 100% !important;
  }
}
</style>